// const MAX_DEFAULT_ZOOM = 17;
// const MAX_DEFAULT_ZOOM = 35

// days
export const WEEKDAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday'
]

// PageLayout categories
export const TA_CAT_HOTEL = 'hotel'
export const TA_CAT_RESTAURANT = 'restaurant'
export const TA_CAT_ATTRACTION = 'attraction'

// Known bounds
export const CENTER_EUROPE = {
  lat: 51.0000003,
  lng: 9.9999997
}



// WEBPACK FOOTER //
// ./src/data/tripadvisor.js